import { useLayoutEffect, useEffect, useState } from 'react';
import { useApiKey, useModalsCount } from '../state';
import * as sdk from 'fetchfox-sdk';
import * as Sentry from '@sentry/react';

import { GlobalContext } from '../context/GlobalContext';

export const GlobalProvider = ({ children }) => {
  const [apiKey, setApiKey] = useApiKey();
  // const user_ = useUser();
  const [fox, setFox] = useState();
  const [sdk_, setSdk_] = useState();
  const [user, setUser] = useState();
  const [host, setHost] = useState();
  const [isDev, setIsDev] = useState(false);
  const modalCounts = useModalsCount();

  useLayoutEffect(() => {
    try {
      console.log('window.location.origin', window.location.origin);
      setIsDev(window.location.origin.includes('localhost') || window.location.origin.includes('dev.app.fetchfox.ai'));
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    console.log('Using API key:', apiKey, sdk);
    console.log('Setting host:', sdk.host());
    setHost(sdk.host());
    if (apiKey) {
      sdk.configure({ apiKey });
      setFox(sdk);
      setSdk_(sdk);
    } else {
      sdk.configure({ apiKey: null });
      setFox(null);
      setSdk_(sdk);
    }
  }, [apiKey]);

  useEffect(() => {
    setUser(null);
    if (!fox) {
      return;
    }
    fox.user.get().then((u) => {
      setUser(u);
      if (u?.admin) {
        Sentry.close();
      }
    });
  }, [fox]);

  const refreshUser = () => fox.user.get().then(setUser);

  return (
    <GlobalContext.Provider value={{ apiKey, setApiKey, user, refreshUser, modalCounts, fox, host, isDev, sdk: sdk_ }}>
      {children}
    </GlobalContext.Provider>
  );
};
